module.exports = "/next-static/_next/static/images/addOnsForMultistreaming-c0f1c0c9e4b49b8fe39f97673f3343fd.png";